
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, ensuring maximum security for all your online activities and sensitive information.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Experience seamless browsing, streaming, and downloading with our optimized VPN servers located strategically around the world.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers in multiple countries worldwide, giving you unrestricted access to content from anywhere on the planet.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and anonymous.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously with one account. Compatible with Windows, Mac, iOS, Android, and more.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always available to help you with any questions or technical issues you may encounter.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Powerful VPN Features
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Advanced security features designed to keep you safe and anonymous online
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
